// @flow
import $ from 'jquery';
import JQueryView, { on } from '../common/JQueryView';
import { fixHeaderTab } from '../../utils/fixHeader';

export default class ShowView extends JQueryView {
  constructor() {
    super('.investors');
    const breakPoint = $('.investor-tab-field').offset().top;
    const tabField = 'investor-tab-field';
    const tabUnderField = 'investor-show-body';

    $(window).on('load scroll', () => {
      fixHeaderTab(breakPoint, tabField, tabUnderField);
    });
  }

  @on({ event: 'click', selector: '.info-link' })
  clickInfoLink(e: any) {
    e.preventDefault();
    $('.tab-link')
      .filter('.active')
      .removeClass('active');
    $('.info-link').addClass('active');
    $('html, body').animate(
      {
        scrollTop: $('#info-section').offset().top,
      },
      1000,
    );
  }

  @on({ event: 'click', selector: '.portfolio-link' })
  clickPortfolioLink(e: any) {
    e.preventDefault();
    $('.tab-link')
      .filter('.active')
      .removeClass('active');
    $('.portfolio-link').addClass('active');
    $('html, body').animate(
      {
        scrollTop: $('#portfolio-section').offset().top,
      },
      1000,
    );
  }
}
